import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { PreviewNode } from '../template-tree';

/** Read-only nested list of classification nodes (template or project tree). */
@Component({
  selector: 'app-classification-preview',
  templateUrl: './classification-preview.component.html',
  styleUrls: ['./classification-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgTemplateOutlet],
})
export class ClassificationPreviewComponent {
  nodes = input<PreviewNode[]>([]);
}
